import React, { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { SITE } from "../lib/site";

const WHATSAPP_NUMBER = SITE.whatsapp;

const DEFAULT_MESSAGE = {
  ro: "Bună ziua, vă contactez de pe site-ul dvs. cu privire la o expertiză tehnică.",
  en: "Hello, I'm reaching out from your website regarding a technical expertise.",
};

export default function WhatsAppFab() {
  const { lang } = useLanguage();
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 800);
    return () => clearTimeout(t);
  }, []);

  if (!mounted) return null;

  const text = DEFAULT_MESSAGE[lang] || DEFAULT_MESSAGE.ro;
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

  const tooltip = lang === "ro" ? "Discutăm pe WhatsApp" : "Chat on WhatsApp";

  return (
    <div className="fixed z-40 bottom-6 left-6 sm:bottom-8 sm:left-8 flex items-end gap-3">
      {open && (
        <div
          data-testid="whatsapp-card"
          className="bg-[#0d0d0d] border border-neutral-800 p-4 max-w-[260px] shadow-2xl"
        >
          <div className="flex items-start justify-between mb-2">
            <div className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-[#25D366]">
              WhatsApp
            </div>
            <button
              onClick={() => setOpen(false)}
              data-testid="whatsapp-close"
              className="text-neutral-500 hover:text-white"
              aria-label="close"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
          <div className="font-display text-sm text-white leading-tight mb-1">
            {SITE.expertName.split(" ").slice(0, 2).join(" ")}
          </div>
          <p className="text-xs text-neutral-400 leading-relaxed">
            {lang === "ro"
              ? "Răspund de obicei în câteva ore. Apăsați pentru a porni conversația."
              : "I usually reply within a few hours. Tap to start the chat."}
          </p>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-open-chat"
            className="mt-3 inline-flex items-center justify-center gap-2 w-full bg-[#25D366] hover:bg-[#1ebe5b] transition-colors text-black font-mono-tech text-[11px] uppercase tracking-[0.15em] py-2.5"
          >
            <MessageCircle className="h-3.5 w-3.5" />
            {lang === "ro" ? "Deschide WhatsApp" : "Open WhatsApp"}
          </a>
        </div>
      )}

      <button
        onClick={() => setOpen((o) => !o)}
        aria-label={tooltip}
        title={tooltip}
        data-testid="whatsapp-fab"
        className="group relative h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-black shadow-[0_8px_24px_-8px_rgba(37,211,102,0.6)] flex items-center justify-center transition-all"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
        <MessageCircle className="relative h-6 w-6" />
      </button>
    </div>
  );
}
